import auth from '../api/auth';

import {
  PASSWORD_RESET_BEGIN,
  PASSWORD_RESET_CLEAR,
  PASSWORD_RESET_FAILURE,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_EMAIL_BEGIN,
  PASSWORD_EMAIL_CLEAR,
  PASSWORD_EMAIL_FAILURE,
  PASSWORD_EMAIL_SUCCESS,
  PASSWORD_CHANGE_FAILURE,
  PASSWORD_CHANGE_REINIT,
} from './types';

export default {
  namespaced: true,
  state: {
    emailCompleted: false,
    emailError: false,
    emailLoading: false,
    resetCompleted: false,
    resetError: false,
    resetLoading: false,
    changePasswdError: false,
    changePasswdRaisonError: null, // le message d'erreur de changement de password retournée par l'API
    emailErrorRaison: null,
    resetErrorRaison: null,
  },
  actions: {
    resetPassword({ commit }, { uid, token, new_password1, new_password2 }) {
      commit(PASSWORD_RESET_BEGIN);
      return auth.resetAccountPassword(uid, token, new_password1, new_password2)
        .then(() => commit(PASSWORD_RESET_SUCCESS))
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // Test des erreurs retournées afin de l'afficher à l'utilisateur.
            // On alimente la raisonError de la LOGIN_FAILURE.
            var errorMessages = "";
            if (error.response.data) {
              console.log(error.response.data)
              
              for (var err in error.response.data) {
                console.log('error --> ' + error.response.data[err].join())
                errorMessages = errorMessages.concat(error.response.data[err].join())
              }
              console.log(errorMessages)
              console.log('errorMessages : ' + errorMessages)
            
              commit(PASSWORD_RESET_FAILURE, errorMessages);
            }
            
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          // console.log(error.config);
        });
    },
    sendPasswordResetEmail({ commit }, { email }) {
      commit(PASSWORD_EMAIL_BEGIN);
      return auth.sendAccountPasswordResetEmail(email)
        .then(() => commit(PASSWORD_EMAIL_SUCCESS))
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // Test des erreurs retournées afin de l'afficher à l'utilisateur.
            // On alimente la raisonError de la LOGIN_FAILURE.
            var errorMessages = "";
            if (error.response.data) {
              console.log(error.response.data)
              
              for (var err in error.response.data) {
                console.log('error --> ' + error.response.data[err].join())
                errorMessages = errorMessages.concat(error.response.data[err].join())
              }
              console.log(errorMessages)
              console.log('errorMessages : ' + errorMessages)
            
              commit(PASSWORD_EMAIL_FAILURE, errorMessages);
            }
            
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          // console.log(error.config);
        });
    },
    clearResetStatus({ commit }) {
      commit(PASSWORD_RESET_CLEAR);
    },
    clearEmailStatus({ commit }) {
      commit(PASSWORD_EMAIL_CLEAR);
    },
    changePassword({ commit }, { new_password1, new_password2 }) {
      return auth.changeAccountPassword(new_password1, new_password2)
        .then(() => commit(PASSWORD_CHANGE_REINIT))
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // Test des erreurs retournées afin de l'afficher à l'utilisateur.
            // On alimente la raisonError de la LOGIN_FAILURE.
            var errorMessages = [];
            if (error.response.data) {
              console.log(error.response.data)
              
              for (var err in error.response.data) {
                
                console.log('error --> ' +  err + ' : ' + error.response.data[err].join())
                errorMessages = errorMessages.concat(err.concat(' : ', error.response.data[err].join()))
              }
              console.log(errorMessages)
              console.log('errorMessages : ' + errorMessages)
            
              commit(PASSWORD_CHANGE_FAILURE, errorMessages);
            }
            
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          // console.log(error.config);
        });
    },
    resetERRORpasswd({ commit }) {
      // Cette action permet de remettre à zero les erreurs de connexion précédentes.
      commit(PASSWORD_CHANGE_REINIT);
    },
  },
  mutations: {
    [PASSWORD_RESET_BEGIN](state) {
      state.resetLoading = true;
    },
    [PASSWORD_RESET_CLEAR](state) {
      state.resetCompleted = false;
      state.resetError = false;
      state.resetLoading = false;
    },
    [PASSWORD_RESET_FAILURE](state, raison) {
      state.resetError = true;
      state.resetLoading = false;
      state.resetErrorRaison = raison;
    },
    [PASSWORD_RESET_SUCCESS](state) {
      state.resetCompleted = true;
      state.resetError = false;
      state.resetLoading = false;
    },
    [PASSWORD_EMAIL_BEGIN](state) {
      state.emailLoading = true;
    },
    [PASSWORD_EMAIL_CLEAR](state) {
      state.emailCompleted = false;
      state.emailError = false;
      state.emailLoading = false;
    },
    [PASSWORD_EMAIL_FAILURE](state, raison) {
      state.emailError = true;
      state.emailLoading = false;
      state.emailErrorRaison = raison;
    },
    [PASSWORD_EMAIL_SUCCESS](state) {
      state.emailCompleted = true;
      state.emailError = false;
      state.emailLoading = false;
    },
    [PASSWORD_CHANGE_FAILURE](state, raison) {
      state.changePasswdError = true
      state.changePasswdRaisonError = raison;
    },
    [PASSWORD_CHANGE_REINIT](state) {
      state.changePasswdError = false;
      state.changePasswdRaisonError = null;
    },
  },
};
